module.exports = __webpack_public_path__ + "static/media/img.e5c0787b.svg";